import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export const CircularProgressComponent = () => {
  return (
    <Box
      sx={{
        minHeight: 240,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  );
};
